import { render, staticRenderFns } from "./securitymanagement.vue?vue&type=template&id=bfc8eb8a&scoped=true&"
import script from "./securitymanagement.vue?vue&type=script&lang=js&"
export * from "./securitymanagement.vue?vue&type=script&lang=js&"
import style0 from "./securitymanagement.vue?vue&type=style&index=0&id=bfc8eb8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc8eb8a",
  null
  
)

export default component.exports